<template>
  <el-button
    :class="classList"
    @click="userClick"
    class="display-inline-block xm-button"
    type="text"
    circle
    :disabled="disabled"
  >{{ label }}
  </el-button
  >
</template>
<script>
export default {
  name: 'XmButton',
  props: {
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    classList: {type: String}
  },
  methods: {
    userClick() {
      this.$emit('button-click')
    }
  }
}
</script>

<style scoped>
@import '../../assets/styles/_variables.css';

.xm-button {
  border-radius: 4px;
  border: 1px solid #c6cbd2;
  background: #FFF;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 21px 12px 20px;

  text-align: center;
  font-family: Arial, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: #606266;

  &.is-disabled {
    color: #EBEEF5;
    border: 1px solid #EBEEF5;
  }

  &:not(.is-disabled):hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/button/XMButton.vue